import type { ColDef, ValueGetterParams } from "ag-grid-enterprise";
import { useMemo } from "react";
import type { StandSetupGridRow } from "../models/MillSetupSheet";

const numeric3 = (value: number | null | undefined): string =>
	value == null ? "" : Number(value).toFixed(3);

export const useStandSetupTableData = () => {
	const columnDefs = useMemo<ColDef<StandSetupGridRow>[]>(
		() => [
			{ headerName: "Stand", field: "StandName", width: 75 },
			{
				headerName: "Pass Id",
				flex: 1.2,
				minWidth: 100,
				// Match legacy display "PassName - PassShapeName". New SP returns
				// PassIdName, legacy returns PassName; both carry PassShapeName.
				valueGetter: (params: ValueGetterParams<StandSetupGridRow>) => {
					const name = params.data?.PassIdName ?? params.data?.PassName;
					if (!name) return "";
					const shape = params.data?.PassShapeName;
					return shape ? `${name} - ${shape}` : name;
				},
			},
			{
				headerName: "Pass Depth",
				field: "PassDepth",
				type: "numericColumn",
				width: 100,
				valueFormatter: (p) => numeric3(p.value),
			},
			{
				headerName: "Pass Width",
				field: "PassWidth",
				type: "numericColumn",
				width: 100,
				valueFormatter: (p) => numeric3(p.value),
			},
			{ headerName: "Bar Size", field: "BarSize", flex: 1.2, minWidth: 110 },
			{
				headerName: "Roll Part",
				field: "RollPart",
				type: "numericColumn",
				width: 95,
				valueFormatter: (p) => numeric3(p.value),
			},
			{ headerName: "Rolled Al", field: "RolledAl", width: 95 },
			{ headerName: "Comments", field: "Comments", flex: 2, minWidth: 130 },
		],
		[],
	);

	return { columnDefs };
};
